import type { AppLanguage } from '@/utils/i18nUtils';

const translationModules = import.meta.glob('./*/translation.json');

/**
 * Lazy-loads the approved Crowdin catalog for a locale.
 * Missing files resolve to an empty catalog so `defaultMessage` renders.
 */
export const loadTranslationCatalog = async (
  locale: AppLanguage
): Promise<Record<string, string>> => {
  const catalogPath = `./${locale}/translation.json`;
  const loadCatalog = translationModules[catalogPath];
  if (!loadCatalog) {
    return {};
  }

  try {
    const catalogModule = (await loadCatalog()) as { default: Record<string, string> };
    return catalogModule.default ?? {};
  } catch {
    return {};
  }
};
